/**
 * EVENTSFLO-ADMIN-BACKUP-UI-COMPONENT-SPLIT-V1
 *
 * Thin endpoint helpers that wrap the 16 SuperAdmin admin-backup
 * endpoints exposed under `/api/admin/backup/*`. No new endpoints, no
 * new request shapes — the URLs, query params and JSON payloads here
 * are an exact 1:1 of what BackupsPage.jsx V1 used.
 */
import api from "../../../lib/api";

// ── read ────────────────────────────────────────────────────────────
export const getStatus = () => api.get("/admin/backup/status");

export const listBackups = (params) =>
  api.get("/admin/backup/list", { params });

export const getManifest = (id) =>
  api.get(`/admin/backup/manifest/${id}`);

export const getSchemaSummary = (id) =>
  api.get(`/admin/backup/${id}/schema-summary`);

export const getDataInventorySnapshot = (id) =>
  api.get(`/admin/backup/${id}/data-inventory-snapshot`);

export const getGdprMapSnapshot = (id) =>
  api.get(`/admin/backup/${id}/gdpr-map-snapshot`);

export const getAuditTrail = (id) =>
  api.get(`/admin/backup/${id}/audit-trail`);

// EVENTSFLO-ADMIN-BACKUP-RESTORE-RUNS-HISTORY-V1 — read-only
// listing of isolated restore runs from `admin_backup_restore_runs`.
export const listRestoreRuns = (params) =>
  api.get("/admin/backup/restore-runs", { params });

// EVENTSFLO-ADMIN-BACKUP-REMINDER-SETTINGS-V1 — read/update
// SuperAdmin-only reminder configuration (singleton).
export const getReminderSettings = () =>
  api.get("/admin/backup/reminder-settings");

export const updateReminderSettings = (body) =>
  api.put("/admin/backup/reminder-settings", body);

// EVENTSFLO-ADMIN-BACKUP-OFFSITE-V1 — manual offsite copy.
export const getOffsiteSettings = () =>
  api.get("/admin/backup/offsite-settings");

export const offsitePreflight = (body) =>
  api.post("/admin/backup/offsite/preflight", body);

export const offsiteCopy = (body) =>
  api.post("/admin/backup/offsite/copy", body);

// EVENTSFLO-ADMIN-BACKUP-OFFSITE-COPIES-HISTORY-V1 — read-only listing.
export const listOffsiteCopies = (params) =>
  api.get("/admin/backup/offsite-copies", { params });

// ── write (manual export / delete) ──────────────────────────────────
export const preflightExport = (opts) =>
  api.post("/admin/backup/preflight", opts);

// Hardcodes `dry_run: false` exactly like BackupsPage V1 did.
export const runExport = (opts) =>
  api.post("/admin/backup/export", { ...opts, dry_run: false });

export const deleteBackup = (id) =>
  api.delete(`/admin/backup/${id}`, { params: { confirm: true } });

// ── restore safety (non-mutating) ───────────────────────────────────
export const restorePreflight = (body) =>
  api.post("/admin/backup/restore/preflight", body);

export const restoreDryRun = (body) =>
  api.post("/admin/backup/restore/dry-run", body);

// ── binary stream ──────────────────────────────────────────────────
export const downloadBackup = (id) =>
  api.get(`/admin/backup/download/${id}`, { responseType: "blob" });

// Lookup used by the inspection drawer's lazy-loader. Mirrors the
// `tabEndpoint` map in BackupsPage V1.
export const inspectionTabFetcher = {
  manifest: getManifest,
  schema: getSchemaSummary,
  inventory: getDataInventorySnapshot,
  gdpr: getGdprMapSnapshot,
  audit: getAuditTrail,
};
